import { Box, Input, InputProps, VStack } from "@chakra-ui/react";
import React from "react";
import { FieldPath, FieldValues, UseFormReturn } from "react-hook-form";
import { FormFieldControl } from "./FormFieldControl";

/**
 * Input field for confirming an action, usually for irreversible destructive
 * actions.
 */
export function ConfirmAnswerInputField<TFormValues extends FieldValues>({
  form,
  name,
  label,
  expectedAnswer,
  instruction,
  ...inputProps
}: {
  form: UseFormReturn<TFormValues>;
  name: FieldPath<TFormValues>;
  label: string;
  expectedAnswer: string;
  instruction?: string;
} & Omit<InputProps, "form" | "name" | "label">) {
  const instructionText =
    instruction ?? `To confirm, type the ${label} exactly as shown:`;

  return (
    <FormFieldControl
      form={form}
      name={name}
      label={instructionText}
      isRequired // confirmation input is never optional
    >
      <VStack w="full" align="flex-start" spacing={2}>
        <Box
          w="full"
          px={3}
          py={2}
          borderWidth="1px"
          borderRadius="md"
          borderColor="gray.200"
          backgroundColor="gray.50"
          fontFamily="mono"
          userSelect="all"
        >
          {expectedAnswer}
        </Box>
        <Input
          placeholder={expectedAnswer}
          type="text"
          {...form.register(name, {
            required: "Confirmation is required",
            validate: (value) =>
              value === expectedAnswer || `${label} does not match.`,
          })}
          {...inputProps}
        />
      </VStack>
    </FormFieldControl>
  );
}
